/* istanbul ignore file */
import _ from 'lodash'
import appAnalytics from '@adc/analytics'
import Cookies from 'js-cookie'

const SHOULD_FIRE_PAGE_GA_TRACKING = false
const analytics = {}

const { eventNames } = appAnalytics

/**
 * Initializes our analytics library and tracks the initial page load.
 *
 * @param {Property}
 * @param {Object}
 */
function initializePageLoaded(
  user = {},
  featureFlags = {},
  overrideOptions = []
) {
  const googleAnalyticsPath = window.location.pathname

  // Setting inital GTM Values
  const dataObject = {
    cookieId: Cookies.get('BRID'),
    event: 'dataLayer-loaded',
    userId: user.user_id || undefined,
    userLoggedIn: user.logged_in,
  }

  if (window.dataLayer) {
    window.dataLayer.push(dataObject)
  }

  appAnalytics.firePageTrackingWithContext(
    googleAnalyticsPath,
    SHOULD_FIRE_PAGE_GA_TRACKING
  )
}
export const trackConversationalFormSubmit = data => {
  appAnalytics.track(eventNames.sellWithUsSubmit, data)
}

export const trackConversationalFormStepLoad = data => {
  appAnalytics.track(eventNames.virtualPageview, data)
}

export const trackConversationalFormSkip = () => {
  appAnalytics.track(eventNames.sellWithUsSkip)
}

export const trackSellWithUsSubmit = data => {
  appAnalytics.track('sell-with-us-submit', data)
}

export const initializeAnalytics = initialState => {
  const userId = initialState.user.user_id
  const featureFlags = initialState.featureFlags
  const configs = _.cloneDeep(window.CONFIGS)
  if (initialState.analyticsConfig?.default_key) {
    _.set(
      configs,
      'analytics.adc.gtm.default_gtm_key',
      initialState.analyticsConfig.default_key
    )
  }
  appAnalytics.init(configs, userId, featureFlags)
}

analytics.initialize = initializePageLoaded
export default analytics
